import React from 'react';
import { observer } from 'mobx-react';
// import { toJS } from 'mobx';
import store from '../../../../../stores/store';
import { MemberCard } from './MemberCard.js';

export const MemberPanel = observer(
    class MemberPanel extends React.Component {
        shouldComponentUpdate(nextProps, nextState) {
            if ((store.groups.selectedGroup !== undefined) && (store.groups.selectedGroup !== null)) {
                return true;
            }
            return false;
        }

        render() {
            let members = [];
            if ((store.groups.selectedGroup !== undefined) && (store.groups.selectedGroup !== null)) {
                members = store.groups.selectedGroup.Members;
            }

            return (
                <div className="d-flex flex-wrap mb-3" id="members-content">
                    {members.map((detail, index) => <MemberCard key={index} detail={detail} />)}
                    <div className="row" />
                </div>
            );
        }
    },
);



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Dashboard/components/Member/MemberPanel.js